<template>
    <div class="pipeline_toggler">
        <button
            v-for="(tab, index) in normalizedTabs"
            :key="index"
            class="pipeline_toggler_btn"
            :class="tab.state ? 'active' : ''"
            @click="selectTab(tab, index)"
        >
            <template v-if="isTextOnly">
                <span class="text-sm">{{ tab.text }}</span>
            </template>
            <template v-else-if="isTextWithIcon">
                <fa :icon="['fal', tab.icon]" />
                <span>{{ tab.text }}</span>
            </template>
            <template v-else>
                <fa :icon="['fal', tab.icon]" />
            </template>
        </button>
    </div>
</template>

<script setup>
import { computed, watch } from "vue";
import { chatroomStatus } from "@/stores/messagesStore";

const emit = defineEmits(["updateView"]);
const props = defineProps({
    tabs: {
        type: Array,
        default: () => [],
        required: true,
    },
    isTextOnly: {
        type: Boolean,
        default: false,
    },
    isTextWithIcon: {
        type: Boolean,
        default: false,
    },
    activeView: {
        type: String,
        default: "",
    },
});

// Normalize tabs: If it's a ref, access `.value`, otherwise use as is
const normalizedTabs = computed(() => {
    return Array.isArray(props.tabs) ? props.tabs : props.tabs.value;
});

const selectTab = (tab, index) => {
    // [todo]: I'm not sure why we are changing chatroomStatus inside a general component. commenting it for now.
    // chatroomStatus.status = tab.emits;
    normalizedTabs.value.forEach((tab, i) => {
        tab.state = i === index; // Set the clicked tab to active
    });

    emit("updateView", normalizedTabs.value[index].emits); // Emit event with the selected tab key
};

watch(
    () => props.activeView,
    (newValue) => {
        if (newValue) {
            normalizedTabs.value.forEach((tab) => (tab.state = false));
            normalizedTabs.value.forEach((tab) => {
                tab.state = newValue === tab.emits;
            });
        }
    },
    { immediate: true }, // Runs immediately on mount
);
</script>

<style scoped>
.pipeline_toggler {
    @apply border xs:border-0 border-white text-gray-500 dark:text-gray-400 bg-gray-100 sm:bg-transparent p-1 sm:p-0 xs:p-[3px] rounded-full sm:rounded inline-flex dark:border-black-500 dark:bg-black-900 max-h-8;
}

.pipeline_toggler_btn {
    @apply text-lg text-gray-500 px-3 h-[30px] xs:h-[26px] border xs:border-0 border-transparent rounded-full sm:rounded inline-flex items-center justify-center dark:text-gray-400;
}

.pipeline_toggler_btn svg {
    @apply text-xl;
}

.pipeline_toggler_btn:last-of-type {
    @apply mr-0;
}

.pipeline_toggler_btn.active {
    @apply bg-white text-black-500 h-[30px] xs:h-[26px] px-3 inline-flex items-center justify-center border xs:border-0 rounded-full sm:rounded text-lg pointer-events-none dark:text-white dark:bg-black-500 dark:border-transparent;
}
.pipeline_toggler_btn:first-of-type.active {
    /* @apply border-r border-l-0 border-t-0 border-b-0; */
}
.pipeline_toggler_btn:last-of-type.active {
    /* @apply border-l border-r-0 border-t-0 border-b-0; */
}
</style>
